import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {
  SessionService,
} from '@kimbocare/core';
import { TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { environment } from '../environments/environment';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  isLoading = true;
  appVersion = environment.appVersion;
  isLoadingLabel = 'Loading...';

  constructor(
    private translateService: TranslateService,
    private sessionService: SessionService,
  ) {
    this.translateService.addLangs(['en', 'fr']);
     this.translateService.setDefaultLang('en');
    const previousChoseLanguage = this.sessionService.getLanguage();
    const browserLang = previousChoseLanguage
      ? previousChoseLanguage
      :  this.translateService.getBrowserLang();
    if (browserLang)
       this.translateService.use(browserLang.match(/en|fr/) ? browserLang : 'en');
  }

  ngOnInit(): void {
    //Because query external parameters from angular app when app is starting  if too busy 😅
  }
}
